import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import SEO, { pageSEO } from "../components/seo.component";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";

export default function Contact() {
  const [popup, setPopup] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    "Email Address": "",
    Message: "",
  });

  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
  } = useUserParams();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  async function submitForm(event) {
    console.log("submitForm");
    event.preventDefault();
    console.log("process.env.REACT_APP_AGENT_EMAIL");
    console.log(process.env.REACT_APP_AGENT_EMAIL);

    const emailFormData = new FormData();
    emailFormData.append('data', JSON.stringify({
      recipientEmails: [getCurrentAgentEmail()],
      senderEmail: process.env.REACT_APP_AGENT_EMAIL,
      subject: "New Contact Form Message",
      content: formData.Message,
      senderName: formData.Name,
      replyTo: formData["Email Address"],
    }));

    let EmailApiUrl = process.env.REACT_APP_NODE_ENV === "production" ? "https://3.138.143.209/global/send-email" : "http://3.138.143.209/global/send-email";


    try {
      const response = await fetch(EmailApiUrl, {
        method: "POST",
        body: emailFormData,
      });

      if (!response.ok) {
        throw new Error("Failed to send email");
      }

      const res = await response.json();
      console.log("res", res);

      if (res?.message === "success") {
        console.log("Success", res);
        setPopup({
          subject: "Thanks for your message!",
          message: "We will get back to you as soon as possible",
        });
        // Clear form after successful submission
        setFormData({
          Name: "",
          "Email Address": "",
          Message: "",
        });
      } else {
        setPopup({
          subject: "We encountered an error in sending this message",
          message: "Please try again later",
        });
      }
    } catch (err) {
      console.log(err);
      setPopup({
        subject: "We encountered an error in sending this message",
        message: "Please try again later",
      });
    }
  }

  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  const seoConfig = pageSEO.contact();
  return (
    <>
      <SEO {...seoConfig} />
      <section className="w-full bg-light-grey flex flex-wrap gap-x-16 gap-y-10 justify-center py-16 px-7">
        <div className="w-full max-w-md">
          <h4 className="font-mont font-semibold text-black text-lg">
            Questions? I&apos;m Here To Help
          </h4>
          <form onSubmit={submitForm} className="mt-6 flex flex-col">
            <div className="form-item">
              <label htmlFor="name" className="form-label">
                Name*
              </label>
              <input
                id="name"
                name="name"
                value={formData.Name}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Full Name"
                required
              />
            </div>
            <div className="form-item">
              <label htmlFor="email" className="form-label">
                Email*
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={formData["Email Address"]}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Email Address"
                required
              />
            </div>
            <div className="form-item">
              <label htmlFor="message" className="form-label">
                Message*
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.Message}
                onChange={handleInputChange}
                className="form-input resize-none h-32"
                placeholder="Your Message"
                required
              />
            </div>
            <button
              type="submit"
              className="btn-primary self-start rounded-none px-10"
            >
              Send
            </button>
            {popup.type && (
              <div
                className={`mt-4 p-4 rounded-md ${popup.type === "success" ? "bg-green-50 text-green-800" : "bg-red-50 text-red-800"
                  }`}
              >
                {popup.message}
              </div>
            )}
          </form>
        </div>
        <div className="w-full max-w-md">
          <div className="relative w-full aspect-[4/3]">
            <iframe
              className="w-full h-full"
              src={constants.MAP}
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black text-2xl">{getCurrentAgentName()}</h2>
            <p className="italic">
              {getCurrentAgentTitle()}, {getCurrentBrokerage()}
            </p>
            <p>
              <FontAwesomeIcon icon={faPhone} className="text-blue-800 fa-lg" />{" "}
              {getCurrentAgentNumber()}
            </p>
            <p>
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-blue-800 fa-lg"
              />{" "}
              {getCurrentAgentEmail()}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
